import React, { ReactElement } from 'react';
import styled from 'styled-components';
import {
  Link,
  paletteHelper,
  spacingHelper,
  typographyHelper,
} from '@construct-kit/core';
import SocialLinks from './SocialLinks';

const NavigationContainer = styled.div`
  background: ${paletteHelper('backgroundPrimary')};
`;

const NavigationStyle = styled.div`
  padding: ${spacingHelper('extraLarge medium medium')};
  ${({ theme }) => theme.layoutBreakpoints.extraLarge} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: ${spacingHelper('small')};
    margin: auto;
    max-width: ${({ theme }) => theme.maxWidth};
  }
`;

const UnorderedLinks = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: ${spacingHelper('medium')};
  ${({ theme }) => theme.layoutBreakpoints.medium} {
    justify-content: center;
  }
  li {
    width: 50%;
    margin-bottom: ${spacingHelper('medium')};
  }
  ${({ theme }) => theme.layoutBreakpoints.medium} {
    li {
      width: auto;
      margin-bottom: 0;
    }
    li + li {
      margin-left: ${spacingHelper('medium')};
    }
  }
  ${({ theme }) => theme.layoutBreakpoints.extraLarge} {
    margin-top: 0;
    padding: ${spacingHelper('medium')} 0;
  }
`;

const TextLink = styled(Link).attrs({ variant: 'secondary' })`
  ${typographyHelper('body02')};
  text-decoration: none;
`;

const NavigationLinks = (): ReactElement => (
  <UnorderedLinks>
    <li>
      <TextLink
        href="https://customer.realestate.com.au/commercial/"
        title="Advertise with realcommercial.com.au"
      >
        Advertise with us
      </TextLink>
    </li>
    <li>
      <TextLink
        href="https://www.realcommercial.com.au/static/rca/about-us/"
        title="About realcommercial.com.au"
      >
        About us
      </TextLink>
    </li>
    <li>
      <TextLink
        href="https://secure.realestate.com.au/sign_in"
        title="Agent administration"
      >
        Agent admin
      </TextLink>
    </li>
    <li>
      <TextLink
        href="https://www.realcommercial.com.au/static/rca/contact-us/"
        title="Contact realcommercial.com.au"
      >
        Contact us
      </TextLink>
    </li>
    <li>
      <TextLink href="https://www.realcommercial.com.au/static/rca/acceptable-use-policy/">
        Terms and conditions
      </TextLink>
    </li>
    <li>
      <TextLink href="https://www.realcommercial.com.au/static/rca/legal/">
        Legal
      </TextLink>
    </li>
    <li>
      <TextLink href="https://www.realcommercial.com.au/static/rca/privacy/">
        Privacy
      </TextLink>
    </li>
    <li>
      <TextLink href="https://careers.realestate.com.au/">Careers</TextLink>
    </li>
    <li>
      <TextLink href="https://www.realcommercial.com.au/sitemap/">
        Site map
      </TextLink>
    </li>
    <li>
      <TextLink href="https://www.realcommercial.com.au/mobile/">
        Mobile apps
      </TextLink>
    </li>
  </UnorderedLinks>
);

const Navigation = (): ReactElement => (
  <NavigationContainer>
    <NavigationStyle>
      <SocialLinks />
      <NavigationLinks />
    </NavigationStyle>
  </NavigationContainer>
);

export default Navigation;
